var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "os-card" },
    [
      _c("h3", { staticClass: "text-center mb-5" }, [
        _vm._v(_vm._s(_vm.$helpers.getMetaTitleText(_vm.$route)))
      ]),
      _vm._v(" "),
      _c(
        "b-form",
        {
          staticClass: "container",
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.signup.apply(null, arguments)
            }
          }
        },
        [
          _vm.$store.state.loading
            ? _c("loading-anim", {
                attrs: { active: _vm.$store.state.loading, fullScreen: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.state.submitted && _vm.form.state.unauthorized
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v(_vm._s(_vm.submitError))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.state.submitted && _vm.form.state.errors
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v(_vm._s(_vm.$t("signupOH.errors.general-code")) + "\n  ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("signupOH.registerNameCenter"),
                  state: _vm.validateState("name")
                },
                on: {
                  input: function($event) {
                    return _vm.resetForm()
                  }
                },
                model: {
                  value: _vm.$v.form.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.name, "$model", $$v)
                  },
                  expression: "$v.form.name.$model"
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    {
                      attrs: {
                        state: _vm.form.name != null && _vm.form.name != ""
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("signupOH.errors.enterCentreName")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("signupOH.registerSanitaryRegister"),
                  state: _vm.validateState("sanitaryRegister")
                },
                on: {
                  input: function($event) {
                    return _vm.resetForm()
                  }
                },
                model: {
                  value: _vm.$v.form.sanitaryRegister.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.sanitaryRegister, "$model", $$v)
                  },
                  expression: "$v.form.sanitaryRegister.$model"
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    {
                      attrs: {
                        state:
                          _vm.form.sanitaryRegister != null &&
                          _vm.form.sanitaryRegister != ""
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("signupOH.errors.enterSanitaryRegister"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("signupOH.registerCodeEnt"),
                  state: _vm.validateState("codPromotion")
                },
                on: {
                  input: function($event) {
                    return _vm.resetForm()
                  }
                },
                model: {
                  value: _vm.$v.form.codPromotion.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.codPromotion, "$model", $$v)
                  },
                  expression: "$v.form.codPromotion.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { staticStyle: { "text-align": "left" } },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { id: "genderForm", name: "genderForm" },
                  model: {
                    value: _vm.withoutLocation,
                    callback: function($$v) {
                      _vm.withoutLocation = $$v
                    },
                    expression: "withoutLocation"
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("signupOH.withoutLocation")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.withoutLocation
            ? _c(
                "b-form-group",
                [
                  _c("base-select", {
                    attrs: {
                      id: "country",
                      searchable: true,
                      placeholder: _vm.$t("signupOH.country"),
                      options: _vm.selectedCountry.options,
                      label: _vm.$i18nHelpers.normalizeProp("name"),
                      valueProp: "idCountry",
                      errorMsg: _vm.$t("signupOH.errors.enterCountry"),
                      clearable: false
                    },
                    on: { change: _vm.reCallProvince },
                    model: {
                      value: _vm.$v.form.countryId.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.form.countryId, "$model", $$v)
                      },
                      expression: "$v.form.countryId.$model"
                    }
                  }),
                  _vm._v(" "),
                  _vm.form.trySubmit
                    ? _c(
                        "b-form-invalid-feedback",
                        { attrs: { state: _vm.form.countryId != null } },
                        [_vm._v(_vm._s(_vm.$t("signupOH.errors.enterCountry")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.withoutLocation
            ? _c(
                "b-form-group",
                [
                  _c("base-select", {
                    attrs: {
                      id: "province",
                      searchable: true,
                      placeholder: _vm.$t("signupOH.registerYourProvince"),
                      options: _vm.selectProvince.options,
                      label: _vm.$i18nHelpers.normalizeProp("name"),
                      valueProp: "id"
                    },
                    model: {
                      value: _vm.$v.form.stateId.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.form.stateId, "$model", $$v)
                      },
                      expression: "$v.form.stateId.$model"
                    }
                  }),
                  _vm._v(" "),
                  _vm.form.trySubmit
                    ? _c(
                        "b-form-invalid-feedback",
                        { attrs: { state: _vm.form.stateId != null } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("signupOH.errors.enterProvince"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("signupOH.registerEmail"),
                  state: _vm.validateState("email")
                },
                on: {
                  input: function($event) {
                    return _vm.resetForm()
                  }
                },
                model: {
                  value: _vm.$v.form.email.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.email, "$model", $$v)
                  },
                  expression: "$v.form.email.$model"
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.form.email != null } },
                    [_vm._v(_vm._s(_vm.$t("signupOH.errors.enterEmail")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("signupOH.confirmEmail"),
                  state: _vm.validateState("emailConfirmation")
                },
                on: {
                  input: function($event) {
                    return _vm.resetForm()
                  }
                },
                model: {
                  value: _vm.$v.form.emailConfirmation.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.emailConfirmation, "$model", $$v)
                  },
                  expression: "$v.form.emailConfirmation.$model"
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.form.emailConfirmation != null } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("signupOH.errors.enterConfirmEmail"))
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    {
                      attrs: {
                        state: _vm.form.emailConfirmation == _vm.form.email
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("signupOH.errors.sameEmails")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("base-select", {
                attrs: {
                  id: "discovery",
                  searchable: true,
                  label: "text",
                  placeholder: _vm.$t("signupOH.selectDiscovery"),
                  options: this.selectDiscovery.options
                },
                model: {
                  value: _vm.form.discoveryCheck,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "discoveryCheck", $$v)
                  },
                  expression: "form.discoveryCheck"
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.form.discoveryCheck != null } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("signupOH.errors.enterDiscoveryType"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              model: {
                value: _vm.form.termsAccepted,
                callback: function($$v) {
                  _vm.$set(_vm.form, "termsAccepted", $$v)
                },
                expression: "form.termsAccepted"
              }
            },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.$t("signupOH.accept-terms")) }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.form.termsAccepted === true } },
                    [_vm._v(_vm._s(_vm.$t("signupOH.errors.termsAccepted")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              model: {
                value: _vm.form.privacyAccepted,
                callback: function($$v) {
                  _vm.$set(_vm.form, "privacyAccepted", $$v)
                },
                expression: "form.privacyAccepted"
              }
            },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("signupOH.accept-privacy"))
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.form.privacyAccepted === true } },
                    [_vm._v(_vm._s(_vm.$t("signupOH.errors.privacyAccepted")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              model: {
                value: _vm.form.dataVerification,
                callback: function($$v) {
                  _vm.$set(_vm.form, "dataVerification", $$v)
                },
                expression: "form.dataVerification"
              }
            },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("signupOH.data-verefication"))
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.form.dataVerification === true } },
                    [_vm._v(_vm._s(_vm.$t("signupOH.errors.dataVerification")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass:
                "align-items-center justify-content-center pb-3 text-center"
            },
            [
              _c("VueRecaptcha", {
                attrs: { sitekey: _vm.siteKey, "load-recaptcha-script": true },
                on: {
                  verify: _vm.handleSuccess,
                  error: _vm.handleError,
                  expired: _vm.handleError
                }
              }),
              _vm._v(" "),
              _vm.form.trySubmit
                ? _c(
                    "b-form-invalid-feedback",
                    { attrs: { state: _vm.form.captcha == true } },
                    [_vm._v(_vm._s(_vm.$t("signupOH.errors.captcha")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "submit", variant: "primary" }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("signupOH.signup-submit")) + "\n  "
              )
            ]
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("signUp.already-registered")) + ", "),
            _c(
              "a",
              {
                staticClass: "log-in-a",
                staticStyle: { cursor: "pointer" },
                on: { click: _vm.goLogin }
              },
              [_vm._v(_vm._s(_vm.$t("sign-up-href")))]
            ),
            _vm._v(".")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9362b0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9362b0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/CentersSignupForm.vue
// module id = 3752
// module chunks = 15